import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { useHistory } from "react-router";
import { GridRowModes } from "@mui/x-data-grid";
import { Card, Input, Container, Row } from "reactstrap";

import {
  failureToast,
  successToast,
} from "../../common/utils/methods/toasterFunctions/function";

import { masterServiceBaseUrl, putpost, putpost2 } from "services/http";
import AToggleButtonGroup from "../../../../../components/AToggleButtonGroup/AToggleButtonGroup";
import { statusFilterOptions } from "../studentFinancials/paymentCollectionSetup/bankMaster/common";

import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";
import CustomButton from "components/CustomButton";

import TableContent from "./TableContent";
import { isObjEmpty } from "../pincode/constants";
import { NEW_EMPTY_ROW } from "./constants";

var _ = require("lodash");

const StateTable = (props) => {
  const history = useHistory();

  const {
    state,
    setstate,
    countries,
    userPermissions,
    isSaveVisible,
    setisSaveVisible = () => {},
    apiloader,
  } = props;

  const [rowData, setRowData] = useState(state);
  const [rowForm, setRowForm] = useState({});
  const [rowModesModel, setRowModesModel] = useState({});

  useEffect(() => {
    setRowData(state);
  }, [state]);

  const startEditing = (id, form) => {
    setRowModesModel((oldModel) => ({
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "countryId" },
    }));

    setRowForm(form);
  };

  const stopEditing = (id) => {
    const currForm = { ...rowForm };

    setRowModesModel((oldModel) => ({
      [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    setRowForm({});
  };

  const saveAll = (rowId) => {
    if (!rowForm["countryId"]) {
      failureToast("Please select the value of Country");
      return;
    } else if (rowForm["stateKey"] === null || !rowForm["stateKey"].trim()) {
      failureToast("Please enter the value of State Key");
      return;
    } else if (rowForm["stateDesc"] === null || !rowForm["stateDesc"].trim()) {
      failureToast("Please enter the value of Description");
      return;
    } else if (
      rowForm["stateDispValue"] === null ||
      !rowForm["stateDispValue"].trim()
    ) {
      failureToast("Please enter the value of Display Value");
      return;
    } else if (
      rowForm["stateGstCode"] === null ||
      !rowForm["stateGstCode"].trim()
    ) {
      failureToast("Please enter the value of State Gst Code");
      return;
    }

    const modifiedPayload = {
      countryId: rowForm.countryId,
      stateKey: rowForm.stateKey,
      stateDesc: rowForm.stateDesc,
      stateDispValue: rowForm.stateDispValue,
      stateGstCode: rowForm.stateGstCode,
      status: rowForm.status,
    };

    if (rowForm?.isNew) {
      putpost(
        masterServiceBaseUrl + "/state/createState",
        (data) => {
          successToast(data["message"]);
          setisSaveVisible(false);
          props.fetchClasses(masterServiceBaseUrl + "/state/getAllState");
          stopEditing(rowId);
        },
        (data) => {
          failureToast(data["message"]);
        },
        modifiedPayload,
        "post"
      );
    } else {
      putpost(
        masterServiceBaseUrl + "/state/updateState/" + rowId,
        (data) => {
          successToast(data["message"]);
          setisSaveVisible(false);
          setRowData(
            rowData.map((state) => (state.id === rowId ? data.data : state))
          );
          setstate(state.map((obj) => (obj.id === rowId ? data.data : obj)));
          stopEditing(rowId);
        },
        (data) => {
          failureToast(data["message"]);
        },
        modifiedPayload,
        "put"
      );
    }
  };

  const newRow = () => {
    if (!isObjEmpty(rowForm)) {
      failureToast("Please Delete or Save current changes");
    } else {
      let randomId = uuidv4();
      let emptyRow = {
        ...NEW_EMPTY_ROW,
        id: randomId,
      };
      startEditing(randomId, emptyRow);
      setRowData((prev) => [emptyRow, ...prev]);
      setisSaveVisible(true);
    }
  };

  const handleCancelClick = async (params) => {
    stopEditing(params?.id);

    if (params?.row?.isNew) {
      setRowData(rowData);
      setRowForm({});
    }
  };

  const deleteRow = (rowId) => {
    if (window.confirm("Are you sure you want to delete this State?")) {
      putpost2(
        masterServiceBaseUrl + "/state/deleteState/" + rowId,
        (data) => {
          successToast(data["message"]);
          setisSaveVisible(false);

          setRowData(rowData.filter((obj) => obj.id !== rowId));
          setstate(state.filter((obj) => obj.id !== rowId));
          //save API call-> props.refreshList();
        },
        (data) => {
          failureToast(data["message"]);
        },
        "Delete"
      );
    }
  };

  const statusFilterChangeHandler = (status) => {
    if (status === "ALL") setRowData(state);
    else {
      setRowData(state.filter((obj) => obj.status === status));
    }

    setRowForm({});
  };

  const filterHandler = _.debounce((stateValue) => {
    const pageSize = 10;
    if (stateValue) {
      const filterCountryList = countries.filter(({ label, value }) =>
        label.toUpperCase().includes(stateValue.toUpperCase())
      );
      const filterData = state.filter(
        (data) =>
          filterCountryList.findIndex(
            (countryCode) => countryCode["value"] === data["countryId"]
          ) >= 0 ||
          data["stateKey"].toUpperCase().includes(stateValue.toUpperCase()) ||
          data["stateDesc"].toUpperCase().includes(stateValue.toUpperCase()) ||
          data["stateDispValue"]
            .toUpperCase()
            .includes(stateValue.toUpperCase()) ||
          data["stateGstCode"]
            .toUpperCase()
            .includes(stateValue.toUpperCase()) ||
          data["status"].toUpperCase().includes(stateValue.toUpperCase())
      );
      setRowData(filterData);
    } else {
      setRowData(state);
    }
  }, 300);

  return (
    <>
      <Container className="mt-3" fluid>
        <Row>
          <div className="col">
            <Card>
              <div className="border-0 p-4">
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <div
                    className={`d-flex align-items-center`}
                    style={{ height: "min-content" }}
                  >
                    <BackIcon
                      className="mr-2 large-text"
                      onClick={() => history.goBack()}
                    />
                    <div className="heading-3 color-black-60 text-bold">
                      State Master
                    </div>
                  </div>

                  <div className="d-flex justify-content-center align-items-center">
                    <Input
                      disabled={isSaveVisible}
                      className="tdInput ml-3"
                      style={{ width: "250px", height: "28px" }}
                      placeholder="Search"
                      onChange={(e) => filterHandler(e.target.value)}
                    />

                    <div className="ml-3" style={{ gap: "10px" }}>
                      <AToggleButtonGroup
                        options={statusFilterOptions}
                        defaultSelected={"ALL"}
                        allowDeselect={false}
                        changeHandler={statusFilterChangeHandler}
                        containerProps={{ disabled: !isObjEmpty(rowForm) }}
                      />
                    </div>

                    <CustomButton
                      className={
                        "mb-0" + isSaveVisible ? " btn-dark cursor-gray" : null
                      }
                      content={"New State"}
                      permissionType={"C"}
                      icon={true}
                      onClick={() => {
                        newRow();
                      }}
                      forTable
                      permissionSet={userPermissions}
                    />
                  </div>
                </div>
              </div>

              <div style={{ height: "72vh", maxHeight: "75vh" }}>
                <TableContent
                  rowData={rowData}
                  rowForm={rowForm}
                  setRowForm={setRowForm}
                  countryList={countries}
                  // allStateList={state}
                  // updateStateOptions={updateStateOptions}
                  saveAll={saveAll}
                  userPermissions={userPermissions}
                  deleteRow={deleteRow}
                  loader={apiloader}
                  setRowData={props?.setRowData}
                  rowModesModel={rowModesModel}
                  startEditing={startEditing}
                  stopEditing={stopEditing}
                  handleCancelClick={handleCancelClick}
                />
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
export default StateTable;
